import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ImageTextOptionElement extends Component {
  holderStyle = {
    width: 100,
    height: 100,
    overflow: 'hidden',
    borderRadius: 12,
    position: 'relative',
    boxShadow: '0 2px 8px rgba(0,0,0,0.12), 0 1px 3px rgba(0,0,0,0.08)',
    transition: 'box-shadow 0.25s ease',
    minWidth: 48,
    minHeight: 48,
  };

  labelStyle = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '0 0 10px 10px',
    background: 'linear-gradient(135deg, rgba(20,126,251,0.95) 0%, rgba(13,95,191,0.95) 100%)',
    backdropFilter: 'blur(4px)',
    WebkitBackdropFilter: 'blur(4px)',
    padding: '8px 4px',
    fontSize: 13,
    fontWeight: 600,
    letterSpacing: 0.3,
    textTransform: 'capitalize',
    textShadow: '0 1px 2px rgba(0,0,0,0.15)',
    lineHeight: 1.2,
    fontFamily: '"Open Sans", sans-serif',
    color: 'white',
    transition: 'background 0.25s ease, padding 0.25s ease',
  };

  constructor(props) {
    super(props);
    const { image, label, value } = props;

    this.childImageStyle = {
      width: '100%',
      height: '100%',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
      backgroundImage: `url(${image})`,
      transition: 'transform 0.4s cubic-bezier(0.4,0,0.2,1), filter 0.3s ease',
    };

    this.state = {
      currentStyle: this.childImageStyle,
      label,
      value,
    };

    this.zoomIn = this.zoomIn.bind(this);
    this.zoomOut = this.zoomOut.bind(this);
  }

  componentDidMount() {
    this.applyResponsiveSize();
    window.addEventListener('resize', this.applyResponsiveSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.applyResponsiveSize);
  }

  applyResponsiveSize = () => {
    const w = window.innerWidth;
    if (w <= 479) {
      this.holderSize = { width: 75, height: 75 };
    } else if (w <= 767) {
      this.holderSize = { width: 85, height: 85 };
    } else {
      this.holderSize = { width: 100, height: 100 };
    }
    this.forceUpdate();
  };

  zoomIn() {
    const { currentStyle } = this.state;
    this.setState({ currentStyle: { ...currentStyle, transform: 'scale(1.08)', filter: 'brightness(1.05)' } });
  }

  zoomOut() {
    this.setState({ currentStyle: this.childImageStyle });
  }

  render() {
    const { currentStyle, label, value } = this.state;
    const size = this.holderSize || { width: 100, height: 100 };

    return (
      <div style={{ ...this.holderStyle, ...size }}>
        <div
          style={currentStyle}
          onMouseEnter={this.zoomIn}
          onMouseLeave={this.zoomOut}
          onClick={() => this.props.clickCallback({ value })}
        />
        <div style={this.labelStyle}>{label}</div>
      </div>
    );
  }
}

ImageTextOptionElement.propTypes = {
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};
